import range from 'lodash/range';
import { TIME_SYSTEM_TEXT } from '../constant';
var parseNumber = function (value, isTwelveHourSystem) {
    var count = isTwelveHourSystem ? value % 12 : value;
    if (isTwelveHourSystem && count === 0)
        return 12;
    return count;
};
var parseNumberToString = function (value, isTwelveHourSystem) {
    var count = parseNumber(value, isTwelveHourSystem);
    return pad(count);
};
/** add miss zero */
var pad = function (num, size) {
    if (size === void 0) { size = 2; }
    var s = "" + num;
    while (s.length < size) {
        s = "0" + s;
    }
    return s;
};
/**
 * get formatted time hh:mm
 * @param option `{hour, min, period}`
 * @param isTwelveHourSystem boolean
 * @returns `hh:mm AM` or `hh:mm PM` or `hh:mm`
 */
var getFormattedTime = function (_a, isTwelveHourSystem) {
    var hour = _a.hour, minute = _a.minute, period = _a.period, periodTexts = _a.periodTexts;
    var formattedHour = parseNumberToString(hour, isTwelveHourSystem);
    var formattedMinute = parseNumberToString(minute);
    var periodText = isTwelveHourSystem ? " " + periodTexts[period] : '';
    return formattedHour + ":" + formattedMinute + periodText;
};
var HALF_DAY_HOURS = 12;
var HOUR_MINUTES = 60;
var TIME_GAP = 5;
var ONE_HOUR = HOUR_MINUTES * HOUR_MINUTES * 1000;
var ONE_MINUTE = HOUR_MINUTES * 1000;
// [0, 12)
var twelveHourSystemSource = range(0, 12);
// [0, 24)
var twentyFourHourSystemSource = range(0, 24);
// [0, 60) step 5
var minuteSource = range(0, 60, TIME_GAP);
var lastMinute = 55;
/**
 * hour and minute timestamp
 */
var getTimestampFromDate = function (date) {
    return date.getHours() * ONE_HOUR + date.getMinutes() * ONE_MINUTE;
};
/**
 * hour and minute number
 */
var getHourAndMinute = function (times) {
    if (times === null) {
        return {
            hour: 0,
            minute: 0,
        };
    }
    var minute = times % ONE_HOUR;
    var hour = (times - minute) / ONE_HOUR;
    return {
        hour: hour,
        minute: Math.floor(minute / ONE_MINUTE),
    };
};
/**
 * get timestamp from date or timestamp
 *
 * if nowTime is number, it must be hour and minute timestamp
 */
function getTimestamp(nowTime) {
    return nowTime instanceof Date ? getTimestampFromDate(nowTime) : nowTime;
}
/**
 * hour and min object to timestamp
 */
var getTimestampFromHourAndMin = function (option) {
    return option.hour * ONE_HOUR + option.minute * ONE_MINUTE;
};
/**
 * get period, `PM` or `AM`
 */
function getPeriod(currHour) {
    return currHour >= HALF_DAY_HOURS ? TIME_SYSTEM_TEXT.PM : TIME_SYSTEM_TEXT.AM;
}
var getRecoupHour = function (currHour, period) {
    switch (period) {
        case TIME_SYSTEM_TEXT.PM:
            if (currHour < HALF_DAY_HOURS) {
                return HALF_DAY_HOURS;
            }
            break;
        case TIME_SYSTEM_TEXT.AM:
            if (currHour < HALF_DAY_HOURS) {
                if (currHour >= HALF_DAY_HOURS) {
                    return -HALF_DAY_HOURS;
                }
            }
            break;
        default:
            break;
    }
    return 0;
};
export { getFormattedTime, getHourAndMinute, getPeriod, getRecoupHour, getTimestamp, getTimestampFromDate, getTimestampFromHourAndMin, HALF_DAY_HOURS, HOUR_MINUTES, lastMinute, minuteSource, ONE_HOUR, pad, parseNumber, parseNumberToString, TIME_GAP, twelveHourSystemSource, twentyFourHourSystemSource, };
